<script>
  import { page } from '$app/stores';
</script>

<section class="static-view error">
  <h1>{$page.status}</h1>

  <div class="title">Ups! Det ser ud til, at noget gik galt.</div>

  <div class="message">{$page.error?.message}</div>

  <a href="/">Gå til forside</a>
</section>
